// React
import { Fragment } from "react"

// Components
import { CommandButton, FooterMenu } from "components"
import { AttachmentModal } from "./AttachmentModal"
import { Print } from "./Print"

// Form
import { useFormContext, useWatch } from "react-hook-form"

// Third-Party Libraries
import { useParams } from "react-router-dom"

// Types
import type { FormSalesOrderType } from "../types"
import { PERMISION } from "security"

type CommandButtonsProps = {
  display?: boolean
  showDeleteButton?: boolean
  showSaveButton?: boolean
  onDelete?: () => void
  onSave?: () => void
}

export const CommandButtons = ({
  display = true,
  showDeleteButton,
  showSaveButton,
  onDelete,
  onSave
}: CommandButtonsProps) => {
  // Hooks
  const { sales_order_id } = useParams()

  // Form
  const { control } = useFormContext<FormSalesOrderType>()
  const approval_status = useWatch({
    control,
    name: "approval_status"
  })

  return (
    <div className={display ? "" : "hidden"}>
      <FooterMenu
        hasCancelButton
        customElement={{
          save: (
            <Fragment>
              {showSaveButton && (
                <CommandButton
                  actiontype="save"
                  type="button"
                  color="primary"
                  permission={PERMISION.SALES.TRANSACTION.CUSTOMER_ORDER.CREATE}
                  onClick={onSave}
                />
              )}
            </Fragment>
          ),

          delete: (
            <Fragment>
              {showDeleteButton && (
                <CommandButton actiontype="delete" onClick={onDelete} />
              )}
            </Fragment>
          ),

          attachment: (
            <AttachmentModal/>
          ),

          print: sales_order_id && approval_status === 4 ? <Print /> : undefined
        }}

      />
    </div>
  )
}
